import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
const scrollToOrder = () => {
  document.getElementById('order-section')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function CTASection() {
  return <Section className="bg-transparent py-32 text-center" data-id="element-52">
      <div className="max-w-3xl mx-auto flex flex-col items-center space-y-8 p-8 md:p-12 bg-black/50 backdrop-blur-md rounded-3xl border border-[#D4AF37]/20 shadow-2xl" data-id="element-53">
        <h2 className="text-4xl md:text-5xl font-bold text-white tracking-tight drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)] text-center" data-id="element-54">
          No esperes a sentirte motivado.
        </h2>

        <p className="text-xl md:text-2xl text-gray-200 font-light leading-relaxed text-center" data-id="element-55">
          La disciplina no depende de la motivación, sino de la acción.{' '}
          <br className="hidden md:block" data-id="element-56" />
          Da el primer paso hoy y transforma tu vida.
        </p>

        <div className="pt-8 flex flex-col items-center" data-id="element-57">
          <Button onClick={scrollToOrder} className="text-lg px-12 py-6 shadow-xl" data-id="element-58">
            Accede al Sistema Anticaos™ Hoy
          </Button>
          <p className="mt-6 text-sm text-gray-400 text-center" data-id="element-59">
            Pago seguro • Acceso inmediato • Garantía de satisfacción
          </p>
        </div>
      </div>
    </Section>;
}